import { AlertCircle } from "lucide-react";

import { LoadingScreen } from "@/components/loading-screen";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useCongress } from "@/features/congress-select/hooks/use-congress";
import { useNotificationAnalytics } from "@/features/upsert-news/api/get-notification-analytics";
import { pageTitle } from "@/utils/page-title";
import { useTranslation } from "react-i18next";

function NotificationsStatisticsPage() {
  const { t } = useTranslation();
  const { congress } = useCongress();
  const {
    data: notificationAnalytics,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useNotificationAnalytics(congress.id);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isError || !isSuccess) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="size-4" />
        <AlertTitle>{t("common.errorTitle")}</AlertTitle>
        <AlertDescription>{error?.message}</AlertDescription>
      </Alert>
    );
  }

  return (
    <div className="space-y-4">
      <title>{pageTitle(t("meta.notifications"))}</title>
      <div className="grid grid-cols-3 gap-6 lg:flex-col">
        <Card>
          <CardHeader className="font-semibold">
            {t("notifications.totalDevices")}
          </CardHeader>
          <CardContent>
            <p className="text-2xl font-bold">
              {notificationAnalytics.totalDevices}
            </p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="font-semibold">{t("notifications.sent")}</CardHeader>
          <CardContent>
            <p className="text-2xl font-bold">
              {notificationAnalytics.totalNotificationsSent}
            </p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="font-semibold">{t("notifications.failed")}</CardHeader>
          <CardContent>
            <p className="text-2xl font-bold">
              {notificationAnalytics.totalNotificationsFailed}
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export { NotificationsStatisticsPage };
